import { render, staticRenderFns } from "./NivelDos.vue?vue&type=template&id=78394bf4"
import script from "./NivelDos.vue?vue&type=script&lang=js"
export * from "./NivelDos.vue?vue&type=script&lang=js"
import style0 from "../main.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports